import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  change() {
    const url = this.menuTarget.value;
    document.location.href = url;
  }
}
